export default __webpack_public_path__ + "static/media/mcdonalds.52975a47.png";